export const DEALER_OPTIONS_LIST = [
  {'text': 'TODOS', 'value': 'ALL'},
  {'text': 'AUTOMOTORES CARLOS LARREA T.CIA.LTDA.', 'value': '1891709478001', 'alias': 'CL'},
  {'text': 'CASABACA S.A.', 'value': '1790009459001', 'alias': 'CB'},
  {'text': 'IMPORTADORA TOMEBAMBA S.A.', 'value': '0190003701001', 'alias': 'IT'},
  {'text': 'TOYOCOSTA S. A.', 'value': '0993144029001', 'alias': 'TC'},
  {'text': 'TOYOTA DEL ECUADOR S.A', 'value': '1792073634001', 'alias': 'TE'},
];


export const TYPE_LIST = [
  {'text': 'TODOS', 'value': 'ALL'},
  {'text': 'FTRs', 'value': 'FTR', 'alias': 'FTR'},
  {'text': 'RSRs', 'value': 'RSR', 'alias': 'RSR'},
  {'text': 'SKRs', 'value': 'SKR', 'alias': 'SKR'},
];
